<app-dialog-header [title]="'Excluded Properties'" (closeClicked)="onClose()">
</app-dialog-header>

<div class="dialog-content">
    <p class="dialog-description">Manage properties which this resource should not attend</p>

    <app-child-entity-manager [childEntityModel]="childEntityModel" [panelMode]="false" [resource]="resource"
        (entityChange)="onEntityChange($event)">
    </app-child-entity-manager>
</div>